import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  icon: {
    width: 'inherit',
    height: 'inherit',
  },
}));
export default useStyles;
